module.exports = __webpack_public_path__ + "img/web-app-development-listing.6457b37b.jpg";